import React from 'react';
export function Header() {
  return <header className="bg-white py-6 border-b border-gray-200 shadow-sm" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="flex items-center justify-center" data-id="element-159">
          <div className="flex items-center" data-id="element-160">
            <div className="h-14 w-14 rounded-lg mr-4 overflow-hidden shadow-sm" data-id="element-161">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hVgGtiNQ7bGPF4edvmUGmT/ChatGPT_Image_Aug_26%2C_2025%2C_02_22_48_PM.png" alt="Frauengesundheit Logo" className="h-full w-full object-cover" data-id="element-162" />
            </div>
            <div data-id="element-163">
              <h1 className="text-gray-900 font-bold text-2xl md:text-3xl leading-tight tracking-tight" data-id="element-164">
                Frauengesundheit Wissen
              </h1>
              <span className="text-red-600 text-sm font-semibold uppercase tracking-wider" data-id="element-165">
                Leserangebot
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>;
}